module.exports = new __parcel__URL__("neon-phrases.a61e054d.mp4").toString();